'use strict';

module.exports = {
    regexp: {
        email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        // Back-office users (admin & client apps): 12 chars min, 1 uppercase, 1 digit, 1 symbol
        password: /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/,
        // Testers: 8 chars min, 1 uppercase, 1 digit, 1 symbol
        testerPassword: /^(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        token: /^[A-Za-z0-9]{20}$/,
        url: /^https?:\/\/.+\..+/,
        phone: /^\+?\d+$/,
        IBAN: /\w{2}(?:\d|\w){25,32}/, // bank informations
        BIC: /(?:\d|\w){8,11}/, // bank informations
    },
    languages: ['fr', 'en']
};
